import { api } from './client';
import { ADMIN_LOOKUP_SIZE, ADMIN_PAGE_SIZE } from './adminTypes';
export async function fetchAdminMenusPage(page = 0, size = ADMIN_PAGE_SIZE) {
    const res = await api.get('/v1/admin/menus', { params: { page, size } });
    return res.data;
}
export async function fetchAdminMenusLookup() {
    const res = await fetchAdminMenusPage(0, ADMIN_LOOKUP_SIZE);
    return res.content;
}
export async function fetchAdminMenu(id) {
    const res = await api.get(`/v1/admin/menus/${id}`);
    return res.data;
}
export async function createAdminMenu(body) {
    const res = await api.post('/v1/admin/menus', body);
    return res.data;
}
export async function updateAdminMenu(id, body) {
    const res = await api.put(`/v1/admin/menus/${id}`, body);
    return res.data;
}
export async function updateAdminMenusOrder(updates) {
    const res = await api.patch('/v1/admin/menus/order', updates);
    return res.data;
}
export async function deleteAdminMenu(id) {
    await api.delete(`/v1/admin/menus/${id}`);
}
export async function fetchAdminCategoriesPage(page = 0, size = ADMIN_PAGE_SIZE) {
    const res = await api.get('/v1/admin/categories', { params: { page, size } });
    return res.data;
}
export async function fetchAdminCategoriesLookup() {
    const res = await fetchAdminCategoriesPage(0, ADMIN_LOOKUP_SIZE);
    return res.content;
}
export async function fetchAdminCategory(id) {
    const res = await api.get(`/v1/admin/categories/${id}`);
    return res.data;
}
export async function createAdminCategory(body) {
    const res = await api.post('/v1/admin/categories', body);
    return res.data;
}
export async function updateAdminCategory(id, body) {
    const res = await api.put(`/v1/admin/categories/${id}`, body);
    return res.data;
}
export async function deleteAdminCategory(id) {
    await api.delete(`/v1/admin/categories/${id}`);
}
export async function fetchAdminCategoryProducts(id) {
    const res = await api.get(`/v1/admin/categories/${id}/products`);
    return res.data;
}
export async function updateAdminCategoryProducts(id, productIds) {
    const res = await api.put(`/v1/admin/categories/${id}/products`, { productIds });
    return res.data;
}
export async function updateAdminMenuCategoriesOrder(menuId, updates) {
    const res = await api.patch(`/v1/admin/menus/${menuId}/categories/order`, updates);
    return res.data;
}
export async function fetchAdminProductsPage(page = 0, size = ADMIN_PAGE_SIZE, params = {}) {
    const res = await api.get('/v1/admin/products', {
        params: { page, size, ...params },
    });
    return res.data;
}
export async function fetchAdminProductsLookup() {
    const res = await fetchAdminProductsPage(0, ADMIN_LOOKUP_SIZE);
    return res.content;
}
export async function fetchAdminActiveProducts() {
    const res = await api.get('/v1/admin/products/active');
    return res.data;
}
export async function fetchAdminActiveProductsForMenu(menuId) {
    const res = await api.get(`/v1/admin/products/active-for-menu/${menuId}`);
    return res.data;
}
export async function fetchAdminProduct(id) {
    const res = await api.get(`/v1/admin/products/${id}`);
    return res.data;
}
export async function fetchAdminProductMenuIds(id) {
    const res = await api.get(`/v1/admin/products/${id}/menu-ids`);
    return res.data;
}
export async function createAdminProduct(body) {
    const res = await api.post('/v1/admin/products', body);
    return res.data;
}
export async function updateAdminProduct(id, body) {
    const res = await api.put(`/v1/admin/products/${id}`, body);
    return res.data;
}
export async function deleteAdminProduct(id) {
    await api.delete(`/v1/admin/products/${id}`);
}
export async function duplicateAdminProduct(id) {
    const res = await api.post(`/v1/admin/products/${id}/duplicate`);
    return res.data;
}
export async function toggleAdminProductStatus(id) {
    const res = await api.patch(`/v1/admin/products/${id}/toggle-status`);
    return res.data;
}
export async function updateAdminProductsOrder(updates) {
    const res = await api.patch('/v1/admin/products/order', updates);
    return res.data;
}
export async function updateAdminProductDisabledRestaurants(id, restaurantIds) {
    const res = await api.put(`/v1/admin/products/${id}/disabled-restaurants`, { restaurantIds });
    return res.data;
}
export async function fetchAdminModifiers() {
    const res = await api.get('/v1/admin/modifiers');
    return res.data;
}
export async function createAdminModifier(body) {
    const res = await api.post('/v1/admin/modifiers', body);
    return res.data;
}
export async function updateAdminModifier(id, body) {
    const res = await api.put(`/v1/admin/modifiers/${id}`, body);
    return res.data;
}
export async function deleteAdminModifier(id) {
    await api.delete(`/v1/admin/modifiers/${id}`);
}
export async function fetchAdminCombosPage(page = 0, size = ADMIN_PAGE_SIZE, search) {
    const res = await api.get('/v1/admin/combos', {
        params: { page, size, search },
    });
    return res.data;
}
export async function fetchAdminCombo(id) {
    const res = await api.get(`/v1/admin/combos/${id}`);
    return res.data;
}
export async function createAdminCombo(body) {
    const res = await api.post('/v1/admin/combos', body);
    return res.data;
}
export async function updateAdminCombo(id, body) {
    const res = await api.put(`/v1/admin/combos/${id}`, body);
    return res.data;
}
export async function deleteAdminCombo(id) {
    await api.delete(`/v1/admin/combos/${id}`);
}
